// extracted by mini-css-extract-plugin
module.exports = {"occup":"author_occup__TEQ99","occup_cr":"author_occup_cr___cjH_","occup_cr_p":"author_occup_cr_p__D85wt"};